import React, { useState } from 'react';
import '../styles/Navbar.scss';

const Navbar = ({ setPage, currentPage }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleNavClick = (item) => {
    setPage(item);
    setMobileMenuOpen(false); // Close menu after clicking
  };

  return (
    <nav className="relative bg-slate-100 text-slate-800 px-4 py-3 shadow font-sans">
      <div className="flex flex-row justify-between items-center">
        <img
          src={`${process.env.PUBLIC_URL || ''}/logo-pl.svg`}
          alt="Phat Le"
          className="h-12 md:h-16 drop-shadow-sm object-contain"
        />
        
        {/* Mobile menu button */}
        <button 
          className="md:hidden hamburger-menu focus:outline-none" 
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <div className={`hamburger-icon ${mobileMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
        
        {/* Desktop menu */}
        <ul className="hidden md:flex flex-row gap-8 list-none m-0 p-0 items-center">
          {['Home', 'About', 'Projects', 'Contact'].map((item) => (
            <li
              key={item}
              className={`cursor-pointer font-medium uppercase tracking-wide transition-colors duration-200 
                ${currentPage === item ? 'text-blue-700 nav-active' : 'hover:text-blue-500'}`}
              onClick={() => setPage(item)}
            >
              {item}
            </li>
          ))}
          <li>
            <a 
              href="/Le Thinh Phat.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="resume-button"
            >
              Resume
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </a>
          </li>
        </ul>
      </div>
      
      {/* Mobile menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <ul className="flex flex-col gap-4 list-none p-0 items-center">
          {['Home', 'About', 'Projects', 'Contact'].map((item) => (
            <li
              key={item}
              className={`cursor-pointer font-medium uppercase tracking-wide transition-colors duration-200 pb-1 border-b-2 w-full text-center py-2
                ${currentPage === item ? 'border-blue-700 text-blue-700' : 'border-transparent hover:text-blue-500'}`}
              onClick={() => handleNavClick(item)}
            >
              {item}
            </li>
          ))}
          <li className="py-3 w-full text-center">
            <a 
              href="/Le Thinh Phat.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="mobile-resume-button"
            >
              Resume
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
